var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8,12.2c-0.4-0.4-0.4-0.9-0.1-1.3l0.1-0.1l4.3-4.3L0.8,2.2C0.4,1.8,0.4,1.3,0.7,0.9l0.1-0.1 c0.4-0.4,0.9-0.4,1.3-0.1l0.1,0.1l5,5c0.4,0.4,0.4,0.9,0.1,1.3L7.2,7.2l-5,5C1.8,12.6,1.2,12.6,0.8,12.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8,12.2c-0.4-0.4-0.4-0.9-0.1-1.3l0.1-0.1l4.3-4.3L5.8,2.2C5.4,1.8,5.4,1.3,5.7,0.9 l0.1-0.1c0.4-0.4,0.9-0.4,1.3-0.1l0.1,0.1l5,5c0.4,0.4,0.4,0.9,0.1,1.3l-0.1,0.1l-5,5C6.8,12.6,6.2,12.6,5.8,12.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.6958f919a3afb3d7e3aeb45d013342ef.svg";
export { ForwardRef as ReactComponent };